require('./brokerSearchWidgetResultList.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @helpers
const { FormattedText } = require('core/i18n').i18n;

// @components
const { BrokerSearchWidgetResult } = require('components/broker/brokerSearchWidgetResult/brokerSearchWidgetResult');

// @commons
const { OKLink } = require('commonsComponents/OKLink');

// @constants
const {
    MYPROFILE_BROKER_EXPLORE_RESULTS_URL,
    ALTERNATIVE_FUNDS,
    ALTERNATIVE_FUNDS_INPUT_VALUE
} = require('constants/index');

class brokerSearchWidgetResultList extends React.Component {

    constructor(props) {
        super(props);
        this.handleSearchAdvancedAllProducts = this.handleSearchAdvancedAllProducts.bind(this);
        this.handleSearchAdvancedProduct = this.handleSearchAdvancedProduct.bind(this);
    }

    buildResultsList(type, list) {
        const instrumentsList = list ? list.get('instrumentsList') : null;
        const total = instrumentsList ? instrumentsList.size : 0;
        if (total > 0) {
            const headerTitle = `brokerSearchWidget-brokerSearchWidget_${type}HeaderTitle`;
            const headerLink = `brokerSearchWidget-brokerSearchWidget_${type}ViewAllLink`;
            const patch = type === ALTERNATIVE_FUNDS ? 'alternative_funds' : type;
            const searchResultsProduct = `${MYPROFILE_BROKER_EXPLORE_RESULTS_URL}/${patch}`;

            const header = (
                <div className="broker-search-widget-result-list__header">
                    <div className="broker-search-widget-result-list__header-title">
                        <FormattedText value={headerTitle} />
                    </div>
                    <div className="broker-search-widget-result-list__header-link">
                        <OKLink
                            to={searchResultsProduct}
                            onClick={() => this.handleSearchAdvancedProduct(type)}
                            modifier="complementary">
                            <FormattedText value={headerLink} />
                        </OKLink>
                    </div>
                </div>
            );

            let resultList = [];
            instrumentsList.forEach((instrument, index) => {
                resultList.push(<BrokerSearchWidgetResult key={index} result={instrument} type={type}/>)
            });

            return (
                <div className="broker-search-widget-result-list__by-type">
                    {header}
                    {resultList}
                </div>
            );
        }

        return null;
    }

    handleSearchAdvancedAllProducts() {// TODO :  cambiar el nombre por ir a buscadores y que esa accion dispare otras
        this.props.searchAdvancedProducts();
        this.props.simpleSearchViewAllLinkTracking();
    }

    handleSearchAdvancedProduct(type) {// TODO :  cambiar el nombre por ir a buscadores y que esa accion dispare otras
        const productType = type === ALTERNATIVE_FUNDS ? ALTERNATIVE_FUNDS_INPUT_VALUE : type.toUpperCase();
        this.props.searchAdvancedProducts(productType);
        this.props.simpleSearchProductLinkTracking(productType);
    }


    buildAllResultsProducts() {
        const headerLink = `brokerSearchWidget-brokerSearchWidget_viewAllResultsLink`;
        const header = (
            <div className="broker-search-widget-result-list__header">
                <div className="broker-search-widget-result-list__header-link">
                    <OKLink
                        to={MYPROFILE_BROKER_EXPLORE_RESULTS_URL}
                        onClick={this.handleSearchAdvancedAllProducts}
                        modifier="complementary"
                    >
                        <FormattedText value={headerLink} />
                    </OKLink>
                </div>
            </div>
        );

        return (
            <div className="broker-search-widget-result-list__by-type">
                {header}
            </div>
        );
    }

    render() {
        const { searchServiceResponse, searchEmpty, isSpecificSearch } = this.props;

        if(!searchEmpty) {
            const buildResultList = [];
            searchServiceResponse.forEach((item, key) => {
                buildResultList.push(this.buildResultsList(key, item));
            });
            const buildLinkAllResultsProducts = isSpecificSearch ? '' : this.buildAllResultsProducts();

            return (
                <div className="broker-search-widget-result-list">
                    {buildResultList}
                    {buildLinkAllResultsProducts}
                </div>
            );
        } else {
            return null;
        }
    }
}

brokerSearchWidgetResultList.propTypes = {
    searchServiceResponse: PropTypes.object.isRequired,
    searchEmpty: PropTypes.bool.isRequired,
    searchAdvancedProducts: PropTypes.func,
    isSpecificSearch: PropTypes.bool,
    simpleSearchProductLinkTracking: PropTypes.func,
    simpleSearchViewAllLinkTracking: PropTypes.func
};

module.exports = brokerSearchWidgetResultList;
